import React, { useEffect, useState } from "react";
import { formatRelativeDate, formatDateDDMMYYYY } from "../../utils/dateUtils";
import Pagination from "../../components/common/Pagination";
import {
  getEmployerStats,
  getEmployers,
  updateEmployerKyc,
  updateEmployerStatus,
  updateEmployerPlan,
  bulkEmployerAction,
  exportEmployers,
} from "../../adminAPI/adminEmployersApi";

const EmployersManagement = () => {
  const token = localStorage.getItem("otoken");

const [stats, setStats] = useState({});
const [employers, setEmployers] = useState([]);

const [selectedIds, setSelectedIds] = useState([]);
// Pagination
const [page, setPage] = useState(1);
const [total, setTotal] = useState(0);
const PAGE_SIZE = Number(process.env.REACT_APP_TABLE_DEF_LENGTH);

const [filters, setFilters] = useState({
  search: "",
  kyc_status: "",
  plan: "",
  status: "",
  date_range: "",
});


const loadStats = async () => {
  const data = await getEmployerStats(token);
  setStats(data);
};

const loadEmployers = async () => {
  const data = await getEmployers(
     { ...filters, page, limit: PAGE_SIZE },
    token
  );
  setEmployers(data.employers || []);
  setTotal(Number(data.total) || 0);
};

const handleBulk = async (action, ids) => {
  await bulkEmployerAction({ action, ids }, token);
  setSelectedIds([]); // ✅ reset selection
  loadEmployers();
};

const handleFilterChange = (e) => {
  setFilters(prev => ({
    ...prev,
    [e.target.name]: e.target.value
  }));
  setPage(1);
};

useEffect(() => {
  loadStats();
  loadEmployers();
}, [page, filters]);


  return (
    <>
            <div className="page-header mb-4 d-flex flex-wrap justify-content-between align-items-center" style={{ marginLeft: "30px", marginRight: "30px" }}>
                <div className="mb-3 mb-md-0">
                    <h1 className="h4 mb-1">Employers Management</h1>
                    <p className="text-muted mb-0">
                    Manage employer accounts, companies, subscription plans, and KYC verification.
                    </p>
                </div>
                <div className="d-flex flex-wrap gap-2">
                    <button 
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => exportEmployers(token)}
                    >
                      <i className="bi-download me-1"></i> Export
                    </button>
                    <button className="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#addEmployerModal">
                    <i className="bi-plus-lg me-1"></i> Add Employer
                    </button>
                </div>
            </div>
        
            <div className="row g-3 mb-4" style={{ marginLeft: "30px", marginRight: "30px" }}>
          <div className="col-md-3">
            <div className="card stats-card shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div>
                  <div className="small text-muted text-uppercase">Total Employers</div>
                  <div className="h5 mb-0">{stats.total_employers}</div>
                  <small className="text-success">
                    <i className="bi-arrow-up-right"></i> 8% this month
                  </small>
                </div>
                <div className="stats-icon bg-primary text-white">
                  <i className="bi-building"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card stats-card shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div>
                  <div className="small text-muted text-uppercase">Verified</div>
                  <div className="h5 mb-0">{stats.verified}</div>
                  <small className="text-success">
                    <i className="bi-check-circle"></i> 72% verified
                  </small>
                </div>
                <div className="stats-icon bg-success text-white">
                  <i className="bi-shield-check"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card stats-card shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div>
                  <div className="small text-muted text-uppercase">Premium</div>
                  <div className="h5 mb-0">{stats.premium}</div>
                  <small className="text-primary">
                    <i className="bi-star"></i> ₹4.2Cr revenue
                  </small>
                </div>
                <div className="stats-icon bg-warning text-white">
                  <i className="bi-star-fill"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card stats-card shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div>
                  <div className="small text-muted text-uppercase">KYC Pending</div>
                  <div className="h5 mb-0">{stats.kyc_pending}</div>
                  <small className="text-danger">
                    <i className="bi-exclamation-triangle"></i> Action needed
                  </small>
                </div>
                <div className="stats-icon bg-danger text-white">
                  <i className="bi-file-earmark-check"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
            
        <div className="card shadow-sm mb-4" style={{ marginLeft: "30px", marginRight: "30px" }}>
          <div className="card-body">
            <form className="row g-3 align-items-end filters-row">
              <div className="col-md-3">
                <label className="form-label small text-muted mb-1">Search</label>
                <div className="input-group input-group-sm">
                  <span className="input-group-text bg-white border-end-0">
                    <i className="bi-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0"
                    placeholder="Company name, email, ID..."
                    name="q"
                    onChange={(e) =>
                      setFilters({ ...filters, search: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-2">
                <label className="form-label small text-muted mb-1">KYC Status</label>
                <select className="form-select form-select-sm" name="kyc_status">
                  <option value="">All</option>
                  <option value="pending">Pending</option>
                  <option value="verified">Verified</option>
                  <option value="rejected">Rejected</option>
                </select>
              </div>
              <div className="col-md-2">
                <label className="form-label small text-muted mb-1">Plan</label>
                <select className="form-select form-select-sm" name="plan">
                  <option value="">All</option>
                  <option value="free">Free</option>
                  <option value="basic">Basic</option>
                  <option value="premium">Premium</option>
                </select>
              </div>
              <div className="col-md-2">
                <label className="form-label small text-muted mb-1">Account Status</label>
                <select className="form-select form-select-sm" name="status">
                  <option value="">All</option>
                  <option value="active">Active</option>
                  <option value="suspended">Suspended</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
              <div className="col-md-2">
                <label className="form-label small text-muted mb-1">Date Range</label>
                <select className="form-select form-select-sm" name="date_range">
                  <option value="">Any time</option>
                  <option value="today">Today</option>
                  <option value="7d">Last 7 days</option>
                  <option value="30d">Last 30 days</option>
                </select>
              </div>
              {/* <div className="col-md-1">
                <button type="submit" className="btn btn-sm btn-primary w-100">
                  Apply
                </button>
              </div> */}
            </form>

            {/* <!-- Active filters chips --> */}
            {/* <div className="mt-3 d-flex flex-wrap align-items-center gap-2">
              <span className="small text-muted me-1">Active filters:</span>
              <span className="badge bg-light text-secondary border filter-chip">
                KYC: Pending <i className="bi-x ms-1"></i>
              </span>
              <span className="badge bg-light text-secondary border filter-chip">
                Plan: Premium <i className="bi-x ms-1"></i>
              </span>
              <button className="btn btn-link btn-sm p-0 small text-decoration-none">
                Clear all
              </button>
            </div> */}
          </div>
        </div>
        <div className="card shadow-sm" style={{ marginLeft: "30px", marginRight: "30px" }}>
          <div className="card-body border-bottom pb-3 d-flex flex-wrap justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2 mb-2 mb-md-0">
              <div className="form-check mb-0">
                
                <label className="form-check-label small" for="selectAllEmployers">
                  Select all
                </label>
              </div>
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-outline-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                >
                  Bulk actions
                </button>
                <ul className="dropdown-menu">
                  <li><button className="dropdown-item" onClick={() => handleBulk("verify_kyc", selectedIds) }   disabled={selectedIds.length === 0}>Verify KYC</button></li>
                  <li><button className="dropdown-item" onClick={() => handleBulk("suspend", selectedIds)}   disabled={selectedIds.length === 0}>Suspend accounts</button></li>
                  <li><button className="dropdown-item"  onClick={() => handleBulk("upgrade_premium", selectedIds)}   disabled={selectedIds.length === 0}>Upgrade to Premium</button></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><button className="dropdown-item text-danger">Delete selected</button></li>
                </ul>
              </div>
              <span className="small text-muted">{selectedIds.length} selected</span>
            </div>

            <div className="d-flex align-items-center gap-2">
              <span className="small text-muted">Sort by:</span>
              <select className="form-select form-select-sm w-auto">
                <option>Newest</option>
                <option>Oldest</option>
                <option>Jobs posted</option>
                <option>Revenue</option>
              </select>
            </div>
          </div>
                    
          <div className="table-responsive">
            <table className="table align-middle mb-0 ml-10">
              <thead>
                <tr>
                  <th style={{width: "50px"}}>
                    <input 
                    className="form-check-input" 
                    type="checkbox" 
                    id="selectAllEmployers"
                    style={{marginTop: "-5px", marginLeft: "8px"}}
                    checked={
                        employers.length > 0 &&
                        selectedIds.length === employers.length
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedIds(employers.map(emp => emp.employer_id));
                        } else {
                          setSelectedIds([]);
                        }
                      }} />
                  </th>
                  <th>Company</th>
                  <th>Plan</th>
                  <th>KYC</th>
                  <th>Jobs</th>
                  <th>Revenue</th>
                  <th>Status</th>
                  <th>Joined</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                {employers.map((emp) => (
                  <tr key={emp.employer_id}>
                    <td>
                      <input 
                        className="form-check-input"
                        style={{marginTop: "-5px", marginLeft: "8px"}} 
                        type="checkbox"
                        id={emp.employer_id}
                        checked={selectedIds.includes(emp.employer_id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedIds([...selectedIds, emp.employer_id]);
                          } else {
                            setSelectedIds(
                              selectedIds.filter(id => id !== emp.employer_id)
                            );
                          }
                        }} />
                    </td>

                    <td>
                      <div className="fw-semibold">{emp.company_name}</div>
                      <small className="text-muted">
                        {emp.employer_code} | {emp.email}
                      </small>
                    </td>

                    <td>
                      <span
                        className={`badge border badge-status ${
                          emp.plan === "premium"
                            ? "bg-success-subtle text-success"
                            : emp.plan === "basic"
                            ? "bg-primary-subtle text-primary"
                            : "bg-light text-secondary"
                        }`}
                      >
                        {emp.plan}
                      </span>
                    </td>

                    <td>
                      <span className={`badge border badge-status ${
                          emp.kyc_status === "verified"
                            ? "bg-success-subtle text-success"
                            : emp.kyc_status === "pending"
                            ? "bg-primary-subtle text-primary"
                            : "bg-light text-secondary"
                        }`}>
                        {emp.kyc_status}
                      </span>
                    </td>

                    <td>
                      <div>{emp.active_jobs} active</div>
                      <small className="text-muted">{emp.total_jobs} total</small>
                    </td>

                    <td>₹{emp.revenue || 0}</td>

                    <td>
                        <span className={`badge border badge-status ${
                          emp.status === "verified"
                            ? "bg-success-subtle text-success"
                            : emp.status === "pending"
                            ? "bg-primary-subtle text-primary"
                            : "bg-light text-secondary"
                        }`}>
                        {emp.status}
                      </span>
                    </td>

                    <td>{formatRelativeDate(emp.created_at)}</td>

                    <td className="text-end">
                      <button
                        className="btn btn-sm btn-outline-success me-1"
                        onClick={() =>
                          updateEmployerKyc(emp.employer_id, "Verified", token)
                        }
                      >
                         <i class="fa fa-solid fa-check"  tooltip="Verify" ></i>
                      </button>

                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() =>
                          updateEmployerStatus(emp.employer_id, "Suspended", token)
                        }
                      >
                      <i class="fa fa-solid fa-pause"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>

            </table>
          </div>

          {/* <!-- Pagination --> */}
           <Pagination
            page={page}
            limit={PAGE_SIZE}
            total={total}
            label="Employers"
            onPageChange={setPage}
          />
        </div>


            </>
        
  );
};

export default EmployersManagement;
